module.exports = __webpack_public_path__ + "img/lc-map.4fa6e2b9.svg";